import { MobileScreenContext } from "@/shared/providers/MobileScreenProvider/context";
import { getBreakpointAsNumber } from "@/shared/utils";
import { useMantineTheme } from "@mantine/core";
import { throttle } from "lodash-es";
import { ReactNode, useEffect, useMemo, useState } from "react";

type MobileScreenProps = {
  children?: ReactNode;
};

export const MobileScreenProvider = ({ children }: MobileScreenProps) => {
  const theme = useMantineTheme();
  const mobileScreenBreakpoint = getBreakpointAsNumber(theme.breakpoints.sm);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth ?? 0);
  const isMobileScreen = screenWidth <= mobileScreenBreakpoint;

  useEffect(() => {
    // Throttle the resize event to avoid unnecessary re-renders
    const throttledHandleResize = throttle(
      () => setScreenWidth(window.innerWidth),
      800
    );
    window.addEventListener("resize", throttledHandleResize);
    return () => window.removeEventListener("resize", throttledHandleResize);
  }, []);

  // Sem memo, todo render do provider recria o objeto e re-renderiza TODOS os
  // consumidores de `useMobileScreen` — que são muitos (SA-1278).
  const value = useMemo(() => ({ isMobileScreen }), [isMobileScreen]);

  return (
    <MobileScreenContext.Provider value={value}>
      {children}
    </MobileScreenContext.Provider>
  );
};
